export default "__VITE_ASSET__CQMJZLKy__"